import { memo, useEffect, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./CreateSociametryTestPage.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getSchoolINedded, getSchoolsINedded } from "redux/actions/setSchoolActions";
import { RootState } from "redux/rootReducer";
import { SchoolsStep } from "pages/tests/SchoolsStep";
import { ProgressBar } from "components/ProgressBar";
import { Layout } from "components/Layout";
import { useHistory } from "react-router-dom";
import { setStep, stepDown, stepUp } from "redux/actions/setTestActions";
import { ClassesStep } from "pages/tests/ClassesStep";
import axios from "axios";
import { hideAlert, showAlert } from "redux/actions/setAppActions";
import { SureAlert } from "components/SureAlert";
import { getClassINedded } from "redux/actions/setClassActions";

interface CreateSociametryTestPageProps {
    className?: string;
}

export const CreateSociametryTestPage = memo((props: CreateSociametryTestPageProps) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [isSureAlert, setIsSureAlert] = useState(false);
    const { step } = useSelector((state: RootState) => state.test);
    const { loading } = useSelector((state: RootState) => state.app);
    const { schools, schoolData, classData } = useSelector((state: RootState) => state.school);

    function onSendClick() {
        setIsSureAlert(true);
    }

    function onCloseClick() {
        setIsSureAlert(false);
        dispatch(stepDown());
    }

    useEffect(() => {
        dispatch(getSchoolsINedded());
    }, [dispatch]);

    const backBtnHandler = () => {
        if (step === 2) {
            dispatch(stepDown());

            history.goBack();
        } else if (step < 2) {
            history.goBack();
        } else {
            dispatch(stepDown());
        }
    };

    useEffect(() => {
        dispatch(setStep(2));
    }, [dispatch]);

    const schoolsHandler = (evt: React.MouseEvent<HTMLLIElement>) => {
        dispatch(getSchoolINedded(evt.currentTarget.id));
        dispatch(stepUp());
    };

    const classesHandler = (evt: React.MouseEvent<HTMLLIElement>) => {
        dispatch(getClassINedded(evt.currentTarget.id));
        dispatch(stepUp());
        onSendClick();
    };

    const sendHandler = async () => {
        try {
            const { data } = await axios.post("sociometry/session", {
                classId: classData._id,
                schoolId: schoolData._id,
            });

            dispatch(showAlert({ type: "success", text: data.message }));

            setTimeout(() => {
                dispatch(hideAlert());
                history.replace("/dashboard");
                history.push("/workWithMethods");
            }, 2000);
        } catch (e: unknown) {
            if (
                e &&
                typeof e === "object" &&
                "response" in e &&
                e.response &&
                typeof e.response === "object" &&
                "data" in e.response &&
                e.response.data &&
                typeof e.response.data === "object" &&
                "message" in e.response.data
            ) {
                dispatch(showAlert({ type: "error", text: e.response.data.message }));
            } else {
                dispatch(showAlert({ type: "error", text: e?.toString() || "Unknown error" }));
            }
        }
    };

    return (
        <Layout>
            <div className="page create-test">
                <header className="page__header">
                    <button
                        className="icon-btn page__icon-btn page__icon-btn_left icon-btn_back"
                        onClick={backBtnHandler}
                    />
                    <p className="page__title">Отправить тест</p>
                </header>

                <ProgressBar step={step} total={4} color="red" />

                <SchoolsStep step={step} loading={loading} schools={schools} clickHandler={schoolsHandler} />
                <ClassesStep loading={loading} step={step} schoolData={schoolData} clickHandler={classesHandler} />
            </div>
            {isSureAlert && (
                <SureAlert
                    type="createTest"
                    handleClose={onCloseClick}
                    handleSubmit={() => {
                        sendHandler();
                        onCloseClick();
                    }}
                />
            )}
        </Layout>
    );
});

CreateSociametryTestPage.displayName = "CreateSociametryTestPage";
